module.exports = "/_next/static/images/bdd93da5c0555bc5691e6efbc96a12e9-apply-xs.jpg.webp";